import React, { type ComponentProps, type FC } from "react";
import { Text, useSitecoreContext } from "@sitecore-jss/sitecore-jss-react"; // eslint-disable-line no-restricted-imports
import parse, { type DOMNode, domToReact, Element } from "html-react-parser";

type TextProps = ComponentProps<typeof Text> & {
	tag?: React.ElementType
}

const TextWrapper: FC<TextProps> = (props) => {
	const { sitecoreContext } = useSitecoreContext();

	if (!props?.field && !sitecoreContext.pageEditing) {
		return <></>;
	}

	const fieldValueString = props.field?.value?.toString() || "";

	if (sitecoreContext.pageEditing && props.editable) {
		return <Text {...props} />;
	}

	if (!fieldValueString.includes("<sup>") && !fieldValueString.includes("<sub>")) {
		return <Text {...props} />;
	}

	const parseHtmlContent = (html: string) => {
		const allowedTags = ["sup", "sub"];

		return parse(html, {
			replace: (domNode: unknown) => {
				if (domNode instanceof Element) {
					const Tag = domNode.tagName as keyof React.JSX.IntrinsicElements;

					if (!allowedTags.includes(domNode.tagName.toLowerCase())) {
						return <></>;
					}

					return (
						<Tag className={`text-${domNode.tagName}`}>
							{domToReact(domNode.children as DOMNode[])}
						</Tag>
					);
				}
			},
		});
	};

	const content = props?.field?.value ? parseHtmlContent(props?.field?.value?.toString()) : null;

	const Tag = props.tag || React.Fragment;

	return (
		<Tag>
			{content}
		</Tag>
	);
};

export default TextWrapper;